import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private isSidebar$ = new BehaviorSubject<boolean>(false);
  private isSuspension$ = new BehaviorSubject<boolean>(false);
  constructor() {}

  getIsSidebar(): Observable<boolean> {
    return this.isSidebar$.asObservable();
  }

  setIsSidebar(isSidebar: boolean) {
    this.isSidebar$.next(isSidebar);
  }

  getIsSuspension(): Observable<boolean> {
    return this.isSuspension$.asObservable();
  }

  setIsSuspension(isSuspension: boolean) {
    this.isSuspension$.next(isSuspension);
  }
}
